export default __webpack_public_path__ + "3e07072d34d4989420e91b18e74894b4.png";